"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeferLiquidityCheckAdapterStorageV3Factory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [],
        name: "WETH",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "allowedDex",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "erc20TokenToTTokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "flashLoanAndLiquidateSlippageTolerance",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lavaBarLimit",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "oracles",
        outputs: [
            {
                internalType: "contract IPriceOracle",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "tTokenToErc20TokenMap",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "vvs",
        outputs: [
            {
                internalType: "contract IVVSRouter02",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b50610249806100206000396000f3fe608060405234801561001057600080fd5b50600436106100785760003560e01c806308e773441461007d5780633395635d146100ad5780638a70e439146100e05780638db35baa14610114578063ad5c46481461012b578063addd50991461013e578063c7fb1c7214610167578063d3393e701461019b575b600080fd5b600154610090906001600160a01b031681565b6040516001600160a01b0390911681526020015b60405180910390f35b6100d06100bb3660046101c0565b60076020526000908152604090205460ff1681565b60405190151581526020016100a4565b6100906100ee3660046101e1565b60036020908152600092835260408084209091529082529020546001600160a01b031681565b61011d60045481565b6040519081526020016100a4565b600054610090906001600160a01b031681565b61009061014c3660046101c0565b6002602052600090815260409020546001600160a01b031681565b6100906101753660046101e1565b60056020908152600092835260408084209091529082529020546001600160a01b031681565b61011d60065481565b80356001600160a01b03811681146101bb57600080fd5b919050565b6000602082840312156101d1578081fd5b6101da826101a4565b9392505050565b600080604083850312156101f3578081fd5b6101fc836101a4565b915061020a602084016101a4565b9050925092905056fea2646970667358221220711870894763314111eb27a230f68ca63682b3781d1e9af73481345723100dcb64736f6c63430008030033";
class DeferLiquidityCheckAdapterStorageV3Factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.DeferLiquidityCheckAdapterStorageV3Factory = DeferLiquidityCheckAdapterStorageV3Factory;
DeferLiquidityCheckAdapterStorageV3Factory.bytecode = _bytecode;
DeferLiquidityCheckAdapterStorageV3Factory.abi = _abi;
//# sourceMappingURL=DeferLiquidityCheckAdapterStorageV3Factory.js.map